<template>
   <div class="un-login-distributeShop">
    <div class="block-header">
      <div class="part-logo">
        <img src="@/assets/logo_orange.png" />
        快麦通
      </div>
      <div class="login-btn">
        <el-button type="primary" @click="handleLogin">立即登录</el-button>
      </div>
    </div>
    <div class="block-body">
      <!-- <div class="block-body-left">
      </div> -->
      <div class="block-body-main">
        <div class="pd32">
          <div class="ftsz16">商品详情</div>
          <BusinessCard
              packUp
              identity="unLoginShare"
              :cardDetail="cardDetail"
              :cooperationDetail="cooperationDetail"
              @login="handleLogin"
          />
          <ProductDetail @abnormal="handleAbnormal" identity="unLoginShare" :isSupplierProduct="true" @login="handleLogin"/>
        </div>
      </div>
    </div>
    <LoginDialog ref="loginDialog" @registe="handleRegiste"/>
    <RegisteDialog ref="registeDialog"  @login="handleLogin"/>
    <Abnormal ref="abnormal"  @login="handleLogin" />
  </div>
</template>

<script>
import BusinessCard from "@supplier/base/BusinessCard";
import ProductDetail from '@/pages/supplier/commodity/shopItemDetail/index.vue'
import LoginDialog from '@pages/unLogin/distributeShop/loginDialog/index.vue'
import RegisteDialog from '@pages/unLogin/distributeShop/loginDialog/registe.vue'
import Abnormal from './abnormal.vue'
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    BusinessCard,
    ProductDetail,
    LoginDialog,
    RegisteDialog,
    Abnormal
  },
  props: {},
  data() {
    return {
      
    };
  },
  computed: {
    ...mapGetters(['shareCompanyInfo']),
    cardDetail() {
      if(this.shareCompanyInfo) {
        return this.shareCompanyInfo
      } else {
        return {
          companyName: '',
          majorCategory: '',
          wx: '',
          phone: '',
          vipMark: false,
          distributionPlatform: [],
          majorPlatform: [],
          video: [],
          picture: [],
          summary: '',
          productId: ''
        }
      }
    },
    cooperationDetail() {
     if(this.shareCompanyInfo && this.shareCompanyInfo.supplyAbilityInfo) {
       return this.shareCompanyInfo.supplyAbilityInfo
     } else {
       return {
        cooperationMode: [], // 合作模式 1: 一件代发、 2:批量采购 - 可多选，逗号分隔
        deliveryTime: 1,
      }
     }
    }
  },
  watch: {
    $route: {
      handler(val) {
        let id = val.query.supplierId || ''
        this.productId = val.query.productId || ''
        if (!id) {
          return;
        }
        this.fetch_shareCompanyInfo({id})
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
     this.$change_color('#2695FA')
  },
  methods: {
    ...mapActions(['fetch_shareCompanyInfo']),
    handleLogin() {
      this.$refs.registeDialog.method_close()
      this.$refs.loginDialog.method_open('detail', this.productId)
    },
    handleRegiste() {
      this.$refs.loginDialog.method_close()
      this.$refs.registeDialog.method_open()
    },
    handleAbnormal(detail) {
      const distributionState = detail.distributionState;
      const privacyState = detail.privacyState;
      // 不可分销 || 私密商品
      if(distributionState == 0 || privacyState == 1) {
        this.$refs.abnormal.method_open();
      }
    }
  },
};
</script>

<style lang="scss" scoped>
$primary: #2695FA;
   .block-header {
      // position: fixed;
      // top: 0;
      box-shadow: 0 2px 5px 0 rgba(0,0,0,0.05);
      height: 50px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      z-index: 2;
      position: relative;
      padding: 0 18px;
      border-top: 2px solid #2695FA;
      .part-logo {
        width: 180px;
        display: flex;
        align-items: center;
        font-size: 16px;
        img {
          width: 26px;
          height: 26px;
          margin-right: 9px;
        }
    }
  }
.block-body {
  width: 100%;
  height: calc(100% - 50px);
  display: flex;
  .block-body-left {
    flex-basis: 180px;
    flex-shrink: 0;
    flex-grow: 0;
    overflow: hidden;
  }
  .block-body-main {
    flex: 1;
    width: calc(100% - 180px);
    overflow-y: auto;
  }
}
</style>